angular.module('account').controller('AccountActivationCtrl',
    ['$scope', 'toaster', 'aprgettext', 'TransitionManager', 'SessionService', 'AccountRepository', 'LocalStorageRepository', '$stateParams', 'debounce', 'configuration', 'ContentAttributeService', 'Bridge',
        function ($scope, toaster, gettext, TransitionManager, SessionService, AccountRepository, LocalStorageRepository, $stateParams, debounce, configuration, ContentAttributeService, Bridge) {
            'use strict';

            $scope.loading = true;
            var webRegistrationId = $stateParams.webRegistrationId;
            $scope.accountActivationDto = {
                ClientId: LocalStorageRepository.getClientID(),
                WebRegistrationId: webRegistrationId,
                UserName: '',
                Password: ''
            };
            $scope.model = {
                ConfirmPassword: '',
                UserNameInUse: false
            };

            function activateAccount() {
                if ($scope.accountActivationForm.$invalid || $scope.model.UserNameInUse || $scope.userNameLoading) {
                    return;
                }


                $scope.submitLoading = true;
                AccountRepository.postAccountActivation($scope.accountActivationDto)
                    .then(function () {
                        toaster.pop('success', '', gettext('Portal account has been successfully created.'));
                        TransitionManager.transition({appRoute: 'login'});
                    })
                    .catch(function () {
                        toaster.pop('error', '', gettext('An error has occurred. Unable to create portal account.'));
                    })
                    .finally(function () {
                        $scope.submitLoading = false;
                    });
            }

            function activateAccountValidation() {
                AccountRepository.postAccountActivationIdValidation($scope.accountActivationDto.ClientId, $scope.accountActivationDto.WebRegistrationId)
                    .catch(function () {
                        toaster.pop('error', '', gettext('Invalid link, timed out.'));
                        TransitionManager.transition({appRoute: 'login'});
                    })
                    .finally(function () {
                        $scope.loading = false;
                    });
            }

            function activateAccountUserNameValidation() {
                $scope.userNameLoading = true;
                AccountRepository.postUserNameValidation($scope.accountActivationDto.ClientId, $scope.accountActivationDto.UserName)
                    .then(function (data) {
                        if (!data.IsSuccess) {
                            $scope.model.UserNameInUse = true;
                            $scope.accountActivationForm.UserName.$invalid = true;
                        } else {
                            $scope.model.UserNameInUse = false;
                        }
                    })
                    .catch(function () {

                    })
                    .finally(function () {
                        $scope.userNameLoading = false;
                    });
            }

            function onLoad() {
                AccountRepository.getActivatePatientPortalMetadata($scope);

                if (!configuration.DEV_HOSTED) {
                    ContentAttributeService.getClientConfig()
                        .then(function (data) {
                            if (data) {
                                var oldClientId = LocalStorageRepository.getClientID();

                                if (oldClientId !== data.clientId) {
                                    LocalStorageRepository.clearAll();
                                }

                                LocalStorageRepository.setClientURL(data.hostUrl);
                                LocalStorageRepository.setClientID(data.clientId);

                            } else {
                                $scope.errorMessage = gettext('Error loading page. Unknown Client Id');
                                Bridge.createModalAlert({
                                    title: gettext('Loading Error'),
                                    message: $scope.errorMessage,
                                    buttons: [gettext('Okay')]
                                });
                            }
                        }).catch(function () {
                            $scope.errorMessage = gettext('Error loading page. Unknown Client Id');
                            Bridge.createModalAlert({
                                title: gettext('Loading Error'),
                                message: $scope.errorMessage,
                                buttons: [gettext('Okay')]
                            });
                        });
                }
                activateAccountValidation();
            }

            function back() {

                SessionService.setDisplayDashboardToolbar(false);
                TransitionManager.transition({appRoute: 'login'});
            }

            onLoad();

            $scope.back = back;
            $scope.activateAccount = activateAccount;
            $scope.activateAccountUserNameValidation = debounce(100, activateAccountUserNameValidation);
        }]);


